export default __webpack_public_path__ + "static/media/WaterFallCR.b2b83349.jpg";